// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"327":"component---node-modules-gatsby-theme-mdx-deck-src-templates-deck-js","809":"component---src-pages-index-mdx"}[chunkId] + "-" + {"327":"082c0d4c08b05027c833","809":"b336cff0128cbe081946"}[chunkId] + ".js";
};